const METADATA_KEY = 'ViewModel:key';
class ViewModelMetadata {
    getParentViewModel(ViewModel) {
        return Reflect.getMetadata(METADATA_KEY, ViewModel);
    }
    setParentViewModel(ParentViewModel, target) {
        Reflect.defineMetadata(METADATA_KEY, ParentViewModel, target);
    }
}
export const viewModelMetadata = new ViewModelMetadata();
